export const trimText = (text, count) => (text && text.length > count ? text.slice(0, count) + '...' : text)
